import { PERSIST_LONG_EXPIRY_DEFAULT, PERSIST_SHORT_EXPIRY_DEFAULT } from 'src/app/popsicle/consts';

export const SCHEMAS = {
  Cart: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  CartItem: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
  },
  HomeScreenItem: {
    expiry: PERSIST_SHORT_EXPIRY_DEFAULT,
  },
  DeliverableZipCodes: {
    expiry: null,
  },
  NewInsurance: {
    expiry: PERSIST_LONG_EXPIRY_DEFAULT,
    attributes: [
      'patient',
      'insurance_company',
      'cardholder_id',
      'group_id',
      'bin',
      'pcn',
      'is_active',
      'created_at',
      'source',
      'is_coupon',
    ],
  },
};
